import getIsValidResendInviteTime from './utils/getIsValidResendInviteTime';
export default function getCanSendInvite({ type, invites }) {
    const invite = invites === null || invites === void 0 ? void 0 : invites.find((invite) => invite.type === type);
    return getIsValidResendInviteTime({
        timeLastInviteSent: invite === null || invite === void 0 ? void 0 : invite.timeRequested
    });
}
//# sourceMappingURL=getCanSendInvite.js.map